<a
  [ngClass]="{
    'bl-menu__link--step-selected': currentPageAdminModule === true ? true : false,
    'bl-menu__link--step-selected bl-menu__link--active':
      currentPageAdminModule === true ? true : false,
    'bl-menu__link bl-menu__link--disabled-role': !access
  }"
  routerLinkActive="bl-menu__link--active"
  title="Management"
  class="bl-menu__link--dark"
  (click)="menu2.toggle($event)"
>
  <i class="pi pi-cog"></i>
  Management
</a>
<p-menu #menu2 [model]="items" [popup]="true" appendTo="body" />
